<template>
  <div class="lang-switcher">
    <template v-for="item in locales" :key="item.code">
      <a
        href="#"
        class="lang-switcher__item"
        :class="{ 'lang-switcher__item--active': item.code === locale }"
        @click.prevent.stop="switchAppLanguage(item.code)">
        {{ item.code }}
      </a>
    </template>
  </div>
</template>
<script lang="js" setup>
const { locales, locale, setLocale } = useI18n()

function switchAppLanguage(locale) {
  setLocale(locale).then(() => {
      reloadNuxtApp()
  })
}
defineProps({
  type: {
    type: String,
    default: 'static',
  },
})
</script>
<style lang="scss">
.lang-switcher {
  align-self: center;
  background: #353535;
  padding: 8px;
  position: v-bind(type);
  top: 55px;
  right: 15px;
  z-index: 100;
  display: flex;
  gap: 10px;
  border-radius: 35px;
  box-sizing: border-box;
  &__item {
    --bg-color: #fff;
    --text-color: #000;
    color: var(--text-color);
    cursor: pointer;
    padding: 5px;
    border-radius: 35px;
    width: 40px;
    text-align: center;
    text-transform: uppercase;
    background-color: var(--bg-color);
    transition: all 0.15s ease;
    &--active {
      --bg-color: #3870ff;
      --text-color: #fff;
    }
    &:hover {
      filter: brightness(0.8);
    }
  }
  &.lang-switcher--static {
  }
}
</style>
